import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

import { QrCode } from '@inter-ikea-kompis/component-qr-code';

import { Text } from '@ingka/common-styles-webc';

import type IProductCardDexfSettings from '../../types/IProductCardDexfSettings.js';
import type IProductCardTranslations from '../../types/IProductCardTranslations.js';
import ProductCardTakeBackReturnInformationQrCardStyle from './ProductCardTakeBackReturnInformationQrCardStyle.js';

export default class ProductCardTakeBackReturnInformationQrCard extends KompisElement {
	// The translations retrieved from translations service.
	@property({ type: Object, required: true })
	public translations!: IProductCardTranslations;

	// The settings retrieved from settings service.
	@property({ type: Object, required: true })
	public settings!: IProductCardDexfSettings;

	public override render(): RenderResult {
		if (!this.settings.kompis.urls.takeBackReturnLink) {
			return null;
		}
		return html`
			<style>
				${ProductCardTakeBackReturnInformationQrCardStyle.getStyle()}
			</style>

			<div class="qr-code-container">
				<div class="qr-code-background">
					<kompis-qr-code
						.url="${this.settings.kompis.urls.takeBackReturnLink}"
						.qrCodeTitle="${this.translations.takeBackReturnQrCodeDescription}"
					></kompis-qr-code>
				</div>
				<p class="qr-code-text ${Text.classnames({ heading: { s: true } })}">
					${this.translations.takeBackReturnQrCodeDescription}
				</p>
			</div>
		`;
	}

	public override async connectedCallback(): Promise<void> {
		this.customElements.define('kompis-qr-code', QrCode);
		super.connectedCallback();
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'kompis-product-card-take-back-return-information-qr-card': ProductCardTakeBackReturnInformationQrCard;
	}
}
